import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {clientsContractsService} from '@store/clients/contracts/clients-contracts.service';
import {ClientsContractsState} from '@store/clients/contracts/clients-contracts.store';

type SearchClientsContractsParams = Partial<ClientsContractsState>

export const searchClientsContractsEffect = createEffectFn((params$: Observable<SearchClientsContractsParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => clientsContractsService.getClientsContracts().pipe(catchError(() => EMPTY))),
  );
});
